import { Component, input } from '@angular/core';

@Component({
  selector: 'app-sidebar-section-title',
  template: `
    <li class="px-2.5 pt-4 pb-2">
      <span class="text-sm font-medium tracking-wider text-gray-400 uppercase">
        {{ title() }}
      </span>
    </li>
  `,
  styles: [],
  standalone: false,
})
export class SidebarSectionTitleComponent {
  title = input.required<string>();
}
